// 加密方法
import CryptoJS from 'crypto-js'

const effectsKey = 'MIIBIjANBgkqhkiG9w0B' // 特效加密key
const keyOfKey = '1ea53d260ecf11e7b56e00163e046a26' // 加密的加密使用
const aesKeyUn = 'AzO6U9pn64HKC62xqqSN5EDCC3trmEAZ' // 接口使用
const aesIvUn = 't+jVw+C//eRbzk0EgohNP0DCC3trmEAZ' // 接口使用
const aesKey = decryptDES(aesKeyUn, keyOfKey)
const aesIv = decryptDES(aesIvUn, keyOfKey)
// AES加密
function encryptAES(text: string) {
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(aesKey), {
    iv: CryptoJS.enc.Utf8.parse(aesIv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

// AES解密
function decryptAES(text: string) {
  const decrypted = CryptoJS.AES.decrypt(
    text,
    CryptoJS.enc.Utf8.parse(aesKey),
    {
      iv: CryptoJS.enc.Utf8.parse(aesIv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// DES解密函数
function decryptDES(ciphertext: string, key: string) {
  // 将密钥转换为WordArray格式
  const keyHex = CryptoJS.enc.Utf8.parse(key)

  // 使用DES算法进行解密，输出为明文
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB, // 选择解密模式
      padding: CryptoJS.pad.Pkcs7 // 选择填充方式
    }
  )

  // 返回明文的UTF-8编码格式
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// MD5加密
function encryptMD5(str: string) {
  return CryptoJS.MD5(str).toString().toUpperCase()
}

// 赋迁改签名
const signKeyUn = 'tmG9+BTG/HRg94xll0JHJoVLltz04XE1kTtosxBc+P5Awgt7a5hAGQ=='
const signKey = decryptDES(signKeyUn, keyOfKey)
function tamperProofSign(objStr: string) {
  if (!objStr) return ''
  return encryptMD5(objStr.replace(/&/g, '') + signKey)
}

export default {
  keyOfKey,
  effectsKey,
  encryptAES,
  decryptAES,
  encryptMD5,
  decryptDES,
  tamperProofSign
}
